<template>
  <div ref="rootElement" class="ecpat-limit" :class="getClasses">
    <img src="@/assets/svg/brown-arrow-up.svg" />
    <transition name="fade" mode="out-in">
      <div>
        <g-button size="small" type="solid" color="brown" @click="onClick">
          Visa Ecpat gräns
        </g-button>
        <g-button @click="onContinue">Gå vidare</g-button>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isVisisible: this.visible,
      isTransitionEnabled: false
    };
  },
  computed: {
    getClasses() {
      return {
        transition: this.isTransitionEnabled
      };
    }
  },
  watch: {
    visible: function(newVal, oldVal) {
      const vh = window.innerHeight;

      const vhHeight = (this.rootHeight / vh) * 100;

      this.isVisisible = newVal;

      if (!oldVal && newVal) {
        this.isTransitionEnabled = true;
        this.$refs['rootElement'].style.transform = 'translateY(0)';
      } else {
        this.$refs['rootElement'].style.transform =
          'translateY(' + vhHeight + 'vh)';
      }
    }
  },

  methods: {
    onClick(e) {
      this.$emit('click', e);
    },
    onContinue(e) {
      this.$emit('continue', e);
    }
  }
};
</script>

<style lang="scss" scoped>
.ecpat-limit {
  align-items: center;
  backdrop-filter: blur(4px);
  background: rgba(254, 231, 217, 0.4);

  border-top: 6px dotted $brown;
  bottom: 0;
  display: flex;
  flex-flow: column nowrap;
  height: 210px;
  justify-content: flex-start;
  left: 0;
  padding-top: 20px;
  position: fixed;
  transform: translateY(210px);
  width: 100%;
  z-index: 3;

  &.transition {
    transition: transform 0.5s ease-out;
  }

  &.show {
    transform: translateY(0);
  }

  img {
    margin-bottom: 10px;
  }
}

.text-wrapper {
  padding: 0 30px 30px;
}

.title {
  margin-bottom: 10px;
}

.text {
  background-color: $orange;
  border-radius: 30px;
  color: #fff;
  padding: 10px 20px;
}
</style>
